import { Action, createReducer, on } from '@ngrx/store';
import { SaveCurrentUserDataAction } from './actions';
import { UserClaims } from '../models';

export interface AuthFeatureState {
  currentUser: UserClaims;
}

const initialState: AuthFeatureState = {
  currentUser: undefined,
};

const reducer = createReducer(
  initialState,
  on(SaveCurrentUserDataAction, (state, action) => {
    return {
      ...state,
      currentUser: { ...action.currentUser, role: action.reducedRole },
    };
  })
);

export function authReducer(state = initialState, action: Action): AuthFeatureState {
  return reducer(state, action);
}
